<template>
  <router-view />
</template>

<script setup lang="ts">
  // --- --- --- App --- --- ---
  import { Dark } from 'quasar';
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  const { locale } = useI18n({ useScope: 'global' });
  // --- --- --- Stores --- --- ---
  import { useSettingsStore } from 'stores/settings.store';
  const oSettingsStore = useSettingsStore();

  // --- --- --- Logica Inicial --- --- ---
  onMounted(() => {
    locale.value = oSettingsStore.language;
    applyTheme(oSettingsStore.themeMode);
  });

  function applyTheme(mode: string){
    switch( mode ){
      case 'dark': Dark.set(true); break;
      case 'light': Dark.set(false); break;
      case 'auto': Dark.set('auto'); break;
    }
  }

</script>
